// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { AnalyticsStore, ContextStore, RouteStore } from 'bernie-core';

// shared-ui
import { ILocalization, withLocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { IndustryStore, UserStore, UserAuthStore } from 'stores';

// ui
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { SignupAHForm } from './signup-ah-form';

interface SignupAHProps {
  analytics?: AnalyticsStore;
  context?: ContextStore;
  industries?: IndustryStore;
  l10n?: ILocalization;
  routeStore?: RouteStore;
  user?: UserStore;
  userAuth?: UserAuthStore;
}

interface SignupAHState {
  industries: string[];
}

@withLocalization
@inject('analytics', 'industries', 'routeStore', 'user', 'context', 'userAuth')
export class SignupAH extends React.Component<SignupAHProps, SignupAHState> {
  public constructor(props) {
    super(props);

    this.state = {
      industries: [],
    };
  }

  public componentDidMount() {
    this.setState({
      industries: this.props.industries.getIndustries(),
    });
  }

  public render() {
    const { context, l10n, routeStore, user } = this.props;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkSpacing padding={{ blockend: 'six' }}>
            <UitkHeading tag="h1" size={3}>
              <LocalizedText message="signup.page.title" />
            </UitkHeading>
          </UitkSpacing>
          <SignupAHForm
            context={context}
            industries={this.state.industries}
            l10n={l10n}
            routeStore={routeStore}
            user={user}
            locale={this.props.context.locale}
          />
        </main>
      </UitkSpacing>
    );
  }
}
